import type { SupportedLanguage } from "@tillix/i18n";

/** The two languages the WGL flows offer; anything else is shown as English. */
export const TOGGLE_LANGUAGES = [
  "en",
  "es",
] as const satisfies readonly SupportedLanguage[];
export type ToggleLanguage = (typeof TOGGLE_LANGUAGES)[number];

export function toToggleLanguage(language: SupportedLanguage): ToggleLanguage {
  return language === "es" ? "es" : "en";
}

/** The language to switch to for a toggle click, or null when nothing changes. */
export function resolveToggleChange(
  current: SupportedLanguage,
  value: string,
): ToggleLanguage | null {
  const next = toToggleLanguage(value as SupportedLanguage);
  return next === current ? null : next;
}
